module.exports = __webpack_public_path__ + "img/no-data.ef7a1b43.png";